import { ExtensionsDocumentation } from "./plugins/plugins";
import Spinner from "../common/Spinner";
import { useDocumentation } from "./documentation-hooks";

const ApiArea = () => {
  const { plugins } = useDocumentation(); 
  return plugins ? <ExtensionsDocumentation extensions={plugins} /> : <Spinner />;
};

export default ApiArea;